import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SmsCreditsPurchaseLayer from "../components/SmsCreditsPurchaseLayer";

const SmsCreditsPurchasePage = () => {
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="רכישת קרדיטים SMS" />
                <SmsCreditsPurchaseLayer />
            </MasterLayout>
        </>
    );
};

export default SmsCreditsPurchasePage;
